import React from 'react';

import { Files } from '~/components/ContractDetails/Files';

import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type ContractFilesViewProps = {
  contractId: string;
  // eslint-disable-next-line react/no-unused-prop-types
  contractIds: string[];
  // eslint-disable-next-line react/no-unused-prop-types
  loading: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  contractDetails: any;
  onBack: () => void;
  // eslint-disable-next-line react/no-unused-prop-types
  onContractChange: (id: string) => void;
};

export function ContractFilesView({ contractId, onBack }: ContractFilesViewProps) {
  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      <Files id={contractId} contractDetailsActionId={contractId} />
    </div>
  );
}
